import { Placeholder } from '@/components';
import styles from './FilterTreezPlaceholder.module.scss';

const FiltersTreezPlaceholder = () => {
  return (
    <>
      <Placeholder className={styles.placeholder__header} />
      <div className={styles.placeholder__filter_container}>
        <Placeholder className={styles.placeholder__filter_btn} />
        <div className={styles.placeholder__filter_container_left}>
          <ul className={styles.placeholder_refinementList__filters_list}>
            {new Array(4).fill(null).map((_, index) => (
              <Placeholder
                className={styles.placeholder__filter_item}
                key={index}
              />
            ))}
          </ul>
        </div>
        <Placeholder className={styles.placeholder__filter_btn_right} />
      </div>
    </>
  );
};

export { FiltersTreezPlaceholder };
